import RootApi from "./requests/root";
import OptionalApi from "./requests/optional";
import CartApi from "./requests/cart";
import ProductsApi from "./requests/products";
import SeriesApi from "./requests/series";
import OrderApi from "./requests/order";
import ProfileApi from "./requests/profile";
import FormApi from "./requests/form";
import MadrobotsApi from "./requests/madrobots";
import XdApi from "./requests/xd";
import TbApi from "./requests/travel-blue";
import MiKuApi from "./requests/mi-ku";
import CompareApi from "./requests/compare";
import FavoritesApi from "./requests/favorites";
import BrandsApi from "./requests/brands";
import GiftCardApi from "./requests/gift-card";
import SaleApi from "./requests/sale";
import FiltersApi from "./requests/filters";

export default {
    install({ store, api }) {
        // Регистрация api
        store.rootApi = RootApi(api);
        store.optionalApi = OptionalApi(api);
        store.cartApi = CartApi(api);
        store.productsApi = ProductsApi(api);
        store.seriesApi = SeriesApi(api);
        store.xdApi = XdApi(api);
        store.orderApi = OrderApi(api);
        store.profileApi = ProfileApi(api);
        store.formApi = FormApi(api);
        store.madrobotsApi = MadrobotsApi(api);
        store.tbApi = TbApi(api);
        store.mikuApi = MiKuApi(api);
        store.compareApi = CompareApi(api);
        store.favoritesApi = FavoritesApi(api);
        store.brandsApi = BrandsApi(api);
        store.giftCardApi = GiftCardApi(api);
        store.saleApi = SaleApi(api);
        store.filtersApi = FiltersApi(api);
    },
};
